import Navigation from './Navigation/Navigation';
import React, { ReactNode } from 'react';
import LandingPageHeader from '../../components/LandingPageHeader/LandingPageHeader';

interface Props {
	children: ReactNode;
	currentPage: number;
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
	isFairEnded: boolean;
}

export const Builder = ({ children, currentPage, setCurrentPage, isFairEnded }: Props) => {
	return (
		<React.Fragment>
			<LandingPageHeader />
			<Navigation isFairEnded={isFairEnded} setCurrentPage={setCurrentPage} currentPage={currentPage} />
			{children}
		</React.Fragment>
	);
};
